import { useLocation } from "react-router-dom";

export const useManagementSettingsViewModel = () => {
  const location = useLocation();

  const pathParts = location.pathname.split("/");
  const activeTab = pathParts[pathParts.length - 1] || "organization-settings";
  const tabs = [
    {
      value: "organization-settings",
      labelKey: "general",
      path: "/management-settings/organization-settings",
      testId: "org-settings-tab-general",
    },
    {
      value: "users",
      labelKey: "users_title",
      path: "/management-settings/users",
      testId: "org-settings-tab-users",
    },
    {
      value: "users-groups",
      labelKey: "user_groups_title",
      path: "/management-settings/users-groups",
      testId: "org-settings-tab-user-groups",
    },
    {
      value: "companies",
      labelKey: "companies_title",
      path: "/management-settings/companies",
      testId: "org-settings-tab-companies",
    },
    {
      value: "company-groups",
      labelKey: "company_groups_title",
      path: "/management-settings/company-groups",
      testId: "org-settings-tab-company-groups",
    },
    {
      value: "roles",
      labelKey: "roles_title",
      path: "/management-settings/roles",
      testId: "org-settings-tab-roles",
    },
  ];

  return {
    activeTab,
    tabs,
    activeTabLabelKey:
      tabs.find((tab) => tab.value === activeTab)?.labelKey ?? "users_title",
  };
};
